<template>
  <div>
    <div
      v-if="!isMobile"
      class="text-center mb-2">
      <h4>
        Share Via
      </h4>
    </div>
    <div
      class="share-actions row pt-2 justify-content-center mx-auto"
      :class="{'mt-xl': isMobile}">
      <div class="col-3 text-center">
        <a
          class="share-link"
          target="_blank"
          :href="mailToLink"
          @click="handleEmailClick">
          <svg-share-email
            background-fill="#850D54"/>
        </a>
      </div>
      <div class="col-3 text-center">
        <a
          class="share-link"
          @click="handleFbClick">
          <svg-share-facebook/>
        </a>
      </div>
      <div
        v-if="isMobile"
        class="col-3 text-center">
        <a
          class="share-link"
          :href="smsLink"
          @click="handleSmsClick">
          <svg-share-sms
            background-fill="#850D54"/>
        </a>
      </div>
      <div class="col-3 text-center">
        <a
          class="share-link"
          @click="handleQrCodeClick">
          <SvgShareQRCode/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import useAnalytics from '@shared/composables/analytics.js'
import SvgShareSms from '@/components/global/svg/SvgShareSms.vue'
import SvgShareEmail from '@/components/global/svg/SvgShareEmail.vue'
import SvgShareFacebook from '@/components/global/svg/SvgShareFacebook.vue'
import SvgShareQRCode from '@/components/global/svg/SvgQRCode.vue'
import { useOverlaysStore } from '@/stores/overlays'
import useScreenSize from '@shared/composables/screenSize.js'

export default {
  name: 'ReferralShareActions',
  components: {
    SvgShareSms,
    SvgShareEmail,
    SvgShareFacebook,
    SvgShareQRCode
  },
  props: {
    referralUrl: {
      type: String,
      required: true
    },
    referralCampaign: {
      type: Object,
      required: true
    }
  },
  setup () {
    const { track } = useAnalytics()
    const { openModal } = useOverlaysStore()
    const { isMobile } = useScreenSize()

    return {
      track,
      openModal,
      isMobile
    }
  },
  computed: {
    isIOS () {
      return window.navigator.platform.indexOf('iPhone') !== -1
    },
    smsLink () {
      // iOS does not honor the IETF SMS url standard
      const link = this.isIOS ? 'sms:&body=' : 'sms:?body='
      return `${link}${encodeURIComponent(this.referralCampaign.textMsgBody)}`
    },
    mailToLink () {
      const body = encodeURIComponent(this.referralCampaign.emailBody)
      const subject = encodeURIComponent(this.referralCampaign.emailSubject)
      return `mailto:?body=${body}&subject=${subject}`
    }
  },
  methods: {
    handleEmailClick () {
      this.track('Shared Referral - Mail')
    },
    handleSmsClick () {
      this.track('Shared Referral - SMS')
    },
    handleFbClick () {
      this.$fb.ui({
        method: 'share',
        href: `${this.referralUrl}?s=fb_post`,
        hashtag: '#bssldypwr',
        quote: this.referralCampaign.facebookPostBody
      }, () => {})
      this.track('Shared Referral - Facebook')
    },
    handleQrCodeClick () {
      this.openModal({name: 'referral-qr-code', options: { track: true }})
    }
  }
}
</script>

<style lang="scss" scoped>
  .share-link {
    cursor: pointer;
  }
  .share-actions {
    max-width: 400px;
  }
</style>
